export const SET_HIGHLIGHT_CD = 'SET_HIGHLIGHT_CD';
export const SET_HOVER_CD = 'SET_HOVER_CD';
export const SET_SELECT_CD = 'SET_SELECT_CD';